export interface FreshchatBootConfig {
  token: string;
  hostUrl: string;
  locale?: string;
  isWidgetHidden?: boolean;
}

export interface FreshchatUserConfig {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  externalId?: string;
}

export const WrapperStates = {
  Booted: 'Booted',
  Down: 'Down',
} as const;

export type WrapperState = (typeof WrapperStates)[keyof typeof WrapperStates];

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fcWidget?: any;
  }
}
